import React from 'react';
import PropTypes from 'prop-types';
import startCase from 'lodash/startCase';

import env from 'Env';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';
import { ScriptTag } from 'Helpers/SEO/Tags';

export default function FacetList({
  facet,
  facets,
  name,
  isMainEntity,
}) {
  if (!facets || !facets.length) {
    return false;
  }

  let fullUrl = window.location.href.split('?')[0];

  if (getUrlParameter('page')) {
    fullUrl = `${fullUrl}?page=${getUrlParameter('page')}`;
  }

  const schema = JSON.stringify({
    '@context': 'https://schema.org',
    '@id': `${fullUrl}#${!isMainEntity ? `${facet}-` : ''}itemlist`,
    '@type': 'ItemList',
    name: name || startCase(facet),
    mainEntityOfPage: !isMainEntity ? undefined : {
      '@id': `${fullUrl}#webpage`,
      '@type': 'CollectionPage',
    },
    itemListElement: facets.map((f, i) => {
      const facetUrl = f.link || `${env.appProtocol}://${env.appUrl}/${window.locale || 'en'}/${facet}/${f.slug}`;

      return {
        '@type': 'ListItem',
        position: i + 1,
        name: f.name,
        item: env.enhanceItemLists ? {
          '@id': `${facetUrl}#${facet === 'franchises' ? 'videogameseries' : 'productcollection'}`,
          '@type': facet === 'franchises' ? 'VideoGameSeries' : 'ProductCollection',
          name: f.name,
          url: facetUrl,
          image: f.cover ? `${env.cdnExtUrl}/product/1280x720/${f.cover}` : undefined,
        } : undefined,
        url: env.enhanceItemLists ? undefined : facetUrl,
      };
    }),
  });

  return <ScriptTag id={`facet-list-${name || startCase(facet)}-schema`} type="application/ld+json" script={schema} />;
}

FacetList.propTypes = {
  facets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isMainEntity: PropTypes.bool,
  facet: PropTypes.string,
  name: PropTypes.string,
};

FacetList.defaultProps = {
  name: '',
  facet: '',
  isMainEntity: false,
};
